import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Cascader,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  message,
  Modal,
  notification,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import { useDispatch, useSelector } from "react-redux"
import {
  CloseOutlined,
  PlusOutlined,
  QuestionCircleTwoTone,
  SearchOutlined,
} from "@ant-design/icons"
import Upload, { RcFile } from "antd/lib/upload"
import { UploadFile } from "antd/lib/upload/interface"
import axios from "axios"
import { RootDispatch } from "../../app/store"
import styles from "./reportCard.module.css"
import {
  HistoryTreatment,
  HistoryTreatmentsRef,
} from "../treatment/surgical/historyTreatment"
import moment from "moment"
import { AXIOS_IP_REPORTCARD, convertToLabelValue } from "./reportCardSlice"
import {
  selectCredentials,
  selectInsuranceArray,
  selectShortName,
  selectStationCategory,
  selectTenantName,
  selectUserName,
} from "../../app/applicationSlice"
import { StationCategory } from "../../models/user"
import { DateTimeFormatSimple } from "../../models/datetime"
import { getPatientDetailInfoAsync } from "../patient/modals/patientSlice"

export const ReportCardModal = (props: {
  visible: boolean
  token: string
  onOk: () => void
  onCancel: () => void
}) => {
  const { Option } = Select

  const { TextArea } = Input

  const dispatch = useDispatch<RootDispatch>()

  const credentials: any = useSelector(selectCredentials)

  const [form] = Form.useForm()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const tenantName = useSelector(selectTenantName)

  const shortName = useSelector(selectShortName)

  const insuranceArray:any = useSelector(selectInsuranceArray)

  const userName = useSelector(selectUserName)

  const stationCategory = useSelector(selectStationCategory)

  const [userMessage, setUserMessage] = useState<any>()

  const [birthDateValue, setBirthDateValue] = useState<any>()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const historyTreatmentsRef = useRef<HistoryTreatmentsRef>(null)

  const [typelist, setTypelist] = useState<any>() // 多个分类

  const [addressOptions, setAddressOptions] = useState<any[]>([]) //全国数据

  const [dieaseData, setDieaseData] = useState<any>() // 传染病

  const [isVisible, setIsVisible] = useState(false)

  const [diagnosisDateValue, setDiagnosisDateValue] = useState<any>()

  const [secondCaseClassificationValue, setSecondCaseClassificationValue] = useState<any>()

  const [isChange, setIsChange] = useState(false) // 判断是否选择病历1

  const firstColumnLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  }

  const secondColumnLayout = {
    labelCol: {
      flex: "0 0 22.22%",
    },
    wrapperCol: {
      flex: "0 0 77.78%",
    },
  }

  const thirdColumnLayout = {
    labelCol: {
      flex: "0 0 38%",
    },
    wrapperCol: {
      flex: "0 0 62%",
    },
  }

  const forthColumnLayout = {
    labelCol: {
      flex: "0 0 11%",
    },
    wrapperCol: {
      flex: "0 0 89%",
    },
  }

  const calculateAge = (birthday: any) => {
    if (!birthday) return 0
    // 兼容 moment 对象和 Date
    const dateObj = (typeof birthday.getMonth === 'function') ? birthday : (birthday.toDate ? birthday.toDate() : new Date(birthday))
    const today = new Date()
    let age = today.getFullYear() - dateObj.getFullYear()
    const monthDiff = today.getMonth() - dateObj.getMonth()
    const dayDiff = today.getDate() - dateObj.getDate()

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--
    }
    return age
  }

  const getData = () => {
    axios({
      url: `${AXIOS_IP_REPORTCARD}/system/dictData/getDicListByDicTypes`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "POST",
      data: [
        "report_card_jurisdiction_category",
        "report_card_nultitude_type",
        "report_first_case_classification",
        "report_second_case_classification",
      ],
    }).then((res) => {
      setTypelist(res.data.data)
    })

    axios({
      url: `${AXIOS_IP_REPORTCARD}/emr/diseaseReport/getDiseaseDict`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "POST",
    }).then((res) => {
      const data = res.data.data
      setDieaseData({
        dieaseA: data?.find((v: any) => v?.category === 0)?.children || [],
        dieaseB: data?.find((v: any) => v?.category === 1)?.children || [],
        dieaseC: data?.find((v: any) => v?.category === 2)?.children || [],
      })
    })

    axios({
      url: `${AXIOS_IP_REPORTCARD}/emr/diseaseReport/regionList`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "GET",
    }).then((res) => {
      // setArealist(res.data.data)
      setAddressOptions(
        (res.data.data || []).map((item: any) => ({
          label: item.name,
          value: item.name,
          code: item.code,
          isLeaf: false,
        }))
      )
    })
  }

  const loadAddressData = (selectedOptions: any[]) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
    axios({
      url: `${AXIOS_IP_REPORTCARD}/emr/diseaseReport/regionList`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      method: "GET",
      params: { code: targetOption.code },
    }).then((res) => {
      targetOption.loading = false
      const children = (res.data.data || []).map((item: any) => ({
        label: item.name,
        value: item.name,
        code: item.code,
        isLeaf: selectedOptions.length >= 3, // 第4级为街道，前三级都不是叶子
      }))
      if (children.length === 0) targetOption.isLeaf = true
      targetOption.children = children
      setAddressOptions([...addressOptions])
    })
  }

  useEffect(() => {
    if (!props.visible) {
      form.resetFields()
      setBirthDateValue(null)
    } else {
      getData()
    }
  }, [props.visible])

  return (
    <>
      <Modal
        title={
          <div style={{ textAlign: "center" }}>中华人民共和国传染病报告卡</div>
        }
        width={1300}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        centered
        maskClosable={false}
        className={styles.selfModal}
        confirmLoading={confirmLoading}
      >
        <Form
          form={form}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
          style={{ paddingRight: 10 }}
          initialValues={{
            category: 1,
            reportTime: moment(),
            sex: 0,
            reportUnit: shortName,
            reportDoctor:
              stationCategory == StationCategory.DoctorOrPharmacist
                ? userName
                : "",
            reportTel:
              stationCategory == StationCategory.DoctorOrPharmacist
                ? credentials?.phone
                : "",
          }}
          onFinish={(vs) => {
            const birthAge = vs?.birthDate ? calculateAge(vs.birthDate) : 0
            const age = vs?.chronologicalAge
            const year = vs?.ageYear
            const month = form.getFieldValue("ageMonth")
            const day = form.getFieldValue("ageDay")
            if (!vs?.birthDate && !age && !year && !month && !day) {
              notification.error({
                message: "年龄信息不能为空",
                duration: 3,
              })
              return
            }
            if (vs?.birthDate) {
              if (birthAge <= 14 && !vs?.parentName) {
                notification.error({
                  message: "14岁及以下的患儿要求填写患者家长姓名",
                  duration: 3,
                })
                return
              }
            } else {
              if ((age <= 14 || year <= 14) && !vs?.parentName) {
                notification.error({
                  message: "14岁及以下的患儿要求填写患者家长姓名",
                  duration: 3,
                })
                return
              }
            }
            if (isVisible && !vs?.nultitudeTypeOther) {
              notification.error({
                message: "人群分类为其他时，请填写其他分类",
                duration: 3,
              })
              return
            }
            if(!vs?.infectiousDiseaseA && !vs?.infectiousDiseaseB 
              && !vs?.infectiousDiseaseC && !vs?.infectiousDiseaseOther) {
                notification.error({
                  message: "请至少选择一种传染病",
                  duration: 3,
                })
                return
            }
            setConfirmLoading(true)
            const params = {
              ...vs,
              medicalRecordId: userMessage?.id,
              currentAddrName:  vs?.currentAddrName ? vs?.currentAddrName?.join('') : '' ,
              infectiousDiseaseB: vs?.infectiousDiseaseB?.map((item: number[]) => item?.[item?.length - 1]),
              birthDate: vs?.birthDate
                ? moment(vs?.birthDate).format("YYYY-MM-DD")
                : "",
              reportTime: vs?.reportTime
                ? [moment(vs?.reportTime).format("YYYY-MM-DD HH:mm:ss")]
                : "",
              onsetDate: vs?.onsetDate
                ? moment(vs?.onsetDate).format("YYYY-MM-DD")
                : "",
              diagnosisDate: vs?.diagnosisDate
                ? [moment(vs?.diagnosisDate).format("YYYY-MM-DD HH:mm:ss")]
                : "",
              deathDate: vs?.deathDate
                ? moment(vs?.deathDate).format("YYYY-MM-DD")
                : "",
            }
            axios({
              url: `${AXIOS_IP_REPORTCARD}/emr/diseaseReport/save`,
              headers: {
                "Content-Type": "application/json",
                "His-Auth": props.token,
              },
              withCredentials: false,
              method: "POST",
              data: params,
            }).then((res) => {
              if(res.data?.msg?.includes('报卡编码已存在')) {
                notification.error({
                  message: "报卡编码已存在",
                  duration: 3,
                })
                setConfirmLoading(false)
              } else {
                notification.success({
                  message: "操作成功",
                  duration: 3,
                })
                setConfirmLoading(false)
                props.onOk()
              }
            })
            // setConfirmLoading(true)
          }}
        >
          <Row justify="space-between">
            <Col span={6}>
              <Form.Item {...firstColumnLayout} name="code" label="卡片编码" rules={[{ required: true }]}>
                <Input
                  size="middle"
                  addonAfter={
                    <>
                      <Popover
                        content={
                          <div>
                            <p>由报告单位自行编制填写。</p>
                          </div>
                        }
                        placement="bottom"
                        title="说明"
                      >
                        <QuestionCircleTwoTone />
                      </Popover>
                    </>
                  }
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                {...firstColumnLayout}
                name="name"
                label="关联病历"
              >
                <Input onClick={() => setIsModalVisible(true)} />
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item
                {...firstColumnLayout}
                name="category"
                label="报卡类别"
                rules={[{ required: true, message: "请选择报卡类别" }]}
              >
                <Radio.Group>
                  <Radio key={1} value={1}>
                    初次报告
                  </Radio>
                  <Radio key={2} value={2}>
                    订正报告
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <div
            style={{
              border: "1px solid #EEEEEE",
              borderRadius: "5px",
              padding: "20px 20px 20px",
              height: 600,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Row>
              <Col span={24}>
                <Row>
                  <Col span={8}>
                    <Form.Item
                      {...firstColumnLayout}
                      name="patientName"
                      label="姓名"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      {...firstColumnLayout}
                      name="parentName"
                      label="（患儿家长姓名"
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item>
                      <span style={{ color: "#666", fontSize: 12 }}>&nbsp;）（14岁及以下的患儿要求填写患者家长姓名）</span>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  {...secondColumnLayout}
                  name="idCard"
                  label="有效证件号"
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  {...secondColumnLayout}
                  name="sex"
                  label="性别"
                  rules={[{ required: true }]}
                >
                  <Radio.Group>
                    <Radio key={1} value={1}>
                      男
                    </Radio>
                    <Radio key={2} value={2}>
                      女
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={7}>
                <Form.Item
                  {...thirdColumnLayout}
                  name="birthDate"
                  label="出生日期"
                  required
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <DatePicker
                      allowClear
                      format="YYYY-MM-DD"
                      value={birthDateValue}
                      placeholder=" 年 / 月 / 日"
                      onChange={(v) => {
                        setBirthDateValue(v)
                        form.setFieldsValue({
                          birthDate: v,
                        })
                      }}
                    />
                    <Popover
                      content={
                        <div>
                          <p>
                            出生日期说明：出生日期与年龄栏只要选择一栏填写即可，不必同时填报出生日期和年龄。
                          </p>
                          <p>实足年龄说明：对出生日期不详的用户填写年龄。</p>
                        </div>
                      }
                      placement="bottom"
                      title="说明"
                    >
                      <div
                        style={{
                          border: "1px solid #EEEEEE",
                          background: "#F4F4F4",
                          padding: "4px 11px",
                          borderLeft: "none",
                        }}
                      >
                        <QuestionCircleTwoTone />
                      </div>
                    </Popover>
                  </div>
                </Form.Item>
              </Col>
              <Col flex="22%">
                <Form.Item
                  labelCol={{ flex: "0 0 77%" }}
                  wrapperCol={{ flex: "0 0 23%" }}
                  name="chronologicalAge"
                  label="( 如出生日期不详，实足年龄"
                >
                  <Input
                    allowClear
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^\d]/g, "")
                      form.setFieldsValue({ chronologicalAge: value })
                      form.validateFields(["birthDate"])
                    }}
                  />
                </Form.Item>
              </Col>
              <Col flex="15%">
                <Form.Item
                  labelCol={{ flex: "0 0 66.5%" }}
                  wrapperCol={{ flex: "0 0 33.5%" }}
                  name="ageYear"
                  label=" 岁 ，年龄单位"
                >
                  <Input
                    allowClear
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^\d]/g, "")
                      form.setFieldsValue({ ageYear: value })
                      form.validateFields(["birthDate"])
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={2}>
                <Form.Item
                  labelCol={{ flex: "0 0 40%" }}
                  wrapperCol={{ flex: "0 0 60%" }}
                  name="ageMonth"
                  label="岁"
                  colon={false}
                >
                  <Input
                    allowClear
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^\d]/g, "")
                      form.setFieldsValue({ ageMonth: value })
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={2}>
                <Form.Item
                  labelCol={{ flex: "0 0 40%" }}
                  wrapperCol={{ flex: "0 0 60%" }}
                  name="ageDay"
                  colon={false}
                  label="月"
                >
                  <Input
                    allowClear
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^\d]/g, "")
                      form.setFieldsValue({ ageDay: value })
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={2}>
                <Form.Item
                  labelCol={{ flex: "0 0 50%" }}
                  wrapperCol={{ flex: "0 0 50%" }}
                  colon={false}
                  label="天 ）"
                >
                  <Popover
                    content={
                      <div>
                        <p>
                          年龄单位说明：对于新生儿和只有月龄的儿童，注意选择年龄单位为天或月。
                        </p>
                      </div>
                    }
                    placement="bottom"
                    title="说明"
                  >
                    <QuestionCircleTwoTone />
                  </Popover>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  {...secondColumnLayout}
                  name="workunit"
                  label="工作单位（学校）"
                >
                  <Input 
                    addonAfter={
                      <>
                        <Popover
                          content={
                            <div>
                              <p>
                                工作单位（学校）说明：填写患者的工作单位。学生、幼托儿童须详细填写所在学校及班级名称。
                              </p>
                            </div>
                          }
                          placement="bottom"
                          title="说明"
                        >
                          <QuestionCircleTwoTone />
                        </Popover>
                      </>
                    }
                    allowClear 
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...secondColumnLayout} name="tel" label="联系电话">
                  <Input allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  {...forthColumnLayout}
                  name="jurisdictionCategory"
                  label="病人属于"
                  rules={[{ required: true, message: "请选择病人属于" }]}
                >
                  <Radio.Group>
                    {typelist?.["report_card_jurisdiction_category"]?.map(
                      (v: any) => {
                        return (
                          <Radio key={v?.id} value={v?.value}>
                            {v?.label}
                          </Radio>
                        )
                      }
                    )}
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col span={12}>
                <Form.Item
                  {...secondColumnLayout}
                  name="currentAddrName"
                  label="现住址（详填）"
                  rules={[
                    {
                      required: true,
                    },
                    {
                      validator: (_, value) => {
                        if (!value || value.length !== 4) {
                          return Promise.reject("请选择到街道")
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                >
                  <Cascader
                    options={addressOptions}
                    loadData={loadAddressData}
                    changeOnSelect
                    placeholder="省/市/区/街道"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="currentAddrDetail" noStyle>
                  <Input
                    addonAfter={
                      <>
                        <Popover
                          content={
                            <div>
                              <p>
                                现住址（详填）说明：至少须详细填写到乡镇（街道）。
                              </p>
                              <p>
                                现住址的填写，原则是指病人发病时的居住地，不是户籍所在地址。
                              </p>
                              <p>
                                如病人不能提供本人现住地址，则填写报告单位地址。
                              </p>
                            </div>
                          }
                          placement="bottom"
                          title="说明"
                        >
                          <QuestionCircleTwoTone />
                        </Popover>
                      </>
                    }
                    placeholder="详细地址"
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col span={8}>
                <Form.Item
                  labelCol={{ flex: "0 0 33.3%" }}
                  wrapperCol={{ flex: "0 0 66.7%" }}
                  name="nultitudeType"
                  label="人群分类"
                  rules={[{ required: true }]}
                >
                  <Select
                    allowClear
                    placeholder="人群分类"
                    onChange={(v) => {
                      if (v == "16") {
                        setIsVisible(true)
                      } else {
                        setIsVisible(false)
                      }
                    }}
                  >
                    {typelist?.["report_card_nultitude_type"]?.map((v: any) => {
                      return (
                        <Select.Option key={v?.id} value={v?.value}>
                          {v?.label}
                        </Select.Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              {isVisible && (
                <Col span={6}>
                  <Form.Item name="nultitudeTypeOther" noStyle>
                    <Input placeholder="输入其他分类" allowClear />
                  </Form.Item>
                </Col>
              )}
            </Row>
            <Row className={styles.formLabelHeight}>
              <Col span={24}>
                <Form.Item
                  {...forthColumnLayout}
                  label="病历分类"
                  name="firstCaseClassification"
                  rules={[{ required: true, message: "请选择病历分类" }]}
                >
                  <div>
                    <Form.Item noStyle rules={[{ required: true }]}>
                      <span>（1）</span>
                      <Radio.Group onChange={() => setIsChange(true)}>
                        {typelist?.["report_first_case_classification"]?.map(
                          (v: any) => {
                            return (
                              <Radio key={v?.id} value={v?.value}>
                                {v?.label}
                              </Radio>
                            )
                          }
                        )}
                      </Radio.Group>
                    </Form.Item>
                    <div style={{ height: 10 }}></div>
                    <Form.Item name="secondCaseClassification" noStyle>
                      <div className={styles.selfFormItem}>
                        <span>（2）</span>
                        <Radio.Group
                          value={secondCaseClassificationValue}
                        >
                          {typelist?.["report_second_case_classification"]?.map(
                            (v: any) => (
                              <Radio 
                                key={v?.id} 
                                value={v?.value}
                                onClick={() => {
                                  const secondValue = form.getFieldValue("secondCaseClassification")
                                  if(v?.value == secondValue) {
                                    form.setFieldsValue({
                                      secondCaseClassification: undefined,
                                    })
                                    setSecondCaseClassificationValue(undefined)
                                  } else {
                                    form.setFieldsValue({
                                      secondCaseClassification: v?.value,
                                    })
                                    setSecondCaseClassificationValue(v?.value)
                                  }
                                }}
                              >
                                {v?.label}
                              </Radio>
                            )
                          )}
                        </Radio.Group>
                        <span>（乙型肝炎*、血吸虫病*、丙肝）</span>
                      </div>
                    </Form.Item>
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  {...forthColumnLayout}
                  name="onsetDate"
                  label="发病日期"
                  rules={[{ required: true, message: "请选择发病日期" }]}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <DatePicker
                      allowClear
                      format="YYYY/MM/DD"
                      placeholder=" 年 / 月 / 日"
                      style={{ width: 180 }}
                      onChange={(v) => {
                        form.setFieldsValue({
                          onsetDate: v,
                        })
                      }}
                    />
                    <span style={{ color: "#666", fontSize: 12 }}>
                      （本次发病日期；病原携带者填初检日期或就诊时间；采供血机构报告填写献血者献血日期。）
                    </span>
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  {...forthColumnLayout}
                  name="diagnosisDate"
                  label="诊断日期"
                  rules={[{ required: true, message: "请选择诊断日期" }]}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <DatePicker
                      allowClear
                      showTime={{
                        format: "HH",
                        hideDisabledOptions: true,
                      }}
                      value={diagnosisDateValue}
                      format="YYYY/MM/DD HH时"
                      style={{ width: 180 }}
                      placeholder=" 年 / 月 / 日"
                      onChange={(v) => {
                        form.setFieldsValue({
                          diagnosisDate: v,
                        })
                        setDiagnosisDateValue(v)
                      }}
                    />
                    <span style={{ color: "#666", fontSize: 12 }}>
                      （本次诊断日期，需填写至小时；采供血机构填写确认实验日期。）
                    </span>
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  {...forthColumnLayout}
                  name="deathDate"
                  label="死亡日期"
                >
                  <DatePicker
                    allowClear
                    format="YYYY/MM/DD"
                    style={{ width: 180 }}
                    placeholder=" 年 / 月 / 日"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Divider style={{ color: "#EEEEEE", marginTop: 0 }} />
            <Row>
              <Col span={24}>
                <Form.Item
                  {...forthColumnLayout}
                  name="infectiousDiseaseA"
                  label="甲类传染病"
                >
                  <Select allowClear placeholder="甲类传染病" mode="multiple">
                    {dieaseData?.dieaseA?.map((v: any) => {
                      return (
                        <Select.Option key={v?.value} value={v?.value}>
                          {v?.label}
                        </Select.Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  {...forthColumnLayout}
                  name="infectiousDiseaseB"
                  label="乙类传染病"
                >
                  <Cascader
                    options={dieaseData?.dieaseB}
                    displayRender={(labels) => labels.join("/")}
                    multiple
                    placeholder="乙类传染病"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  {...forthColumnLayout}
                  name="infectiousDiseaseC"
                  label="丙类传染病"
                >
                  <Select allowClear placeholder="丙类传染病" mode="multiple">
                    {dieaseData?.dieaseC?.map((v: any) => {
                      return (
                        <Select.Option key={v?.value} value={v?.value}>
                          {v?.label}
                        </Select.Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row className={styles.rowsBreak}>
              <Col span={24}>
                <Form.Item
                  {...forthColumnLayout}
                  name="infectiousDiseaseOther"
                  label="其他法定管理以及重点监测传染病"
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Divider style={{ color: "#EEEEEE", marginTop: 0 }} />
            <Row>
              <Col span={12}>
                <Form.Item
                  {...secondColumnLayout}
                  name="correctedDiseaseName"
                  label="订正病名"
                >
                  <Input
                    addonAfter={
                      <>
                        <Popover
                          content={
                            <div>
                              <p>订正病名说明：订正报告填写订正前的病名。</p>
                            </div>
                          }
                          placement="bottom"
                          title="说明"
                        >
                          <QuestionCircleTwoTone />
                        </Popover>
                      </>
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  {...secondColumnLayout}
                  name="rejectionReason"
                  label="退卡原因"
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  {...secondColumnLayout}
                  name="reportUnit"
                  label="报告单位"
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  {...secondColumnLayout}
                  name="reportTel"
                  label="联系电话"
                  // rules={[
                  //   {
                  //     pattern: /^1[3-9]\d{9}$/,
                  //     message: '请输入有效的手机号',
                  //   },
                  // ]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  {...secondColumnLayout}
                  name="reportDoctor"
                  label="填卡医生"
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  {...secondColumnLayout}
                  name="reportTime"
                  label="填卡日期"
                  rules={[{ required: true, message: "请选择填卡日期" }]}
                >
                  <DatePicker
                    allowClear
                    format="YYYY/MM/DD"
                    style={{ width: "100%" }}
                    placeholder=" 年 / 月 / 日"
                  />
                </Form.Item>
              </Col>
              <Divider style={{ color: "#EEEEEE", marginTop: 0 }} />
              <Col span={24}>
                <Form.Item
                  {...forthColumnLayout}
                  name="memo"
                  label="备注"
                >
                  <TextArea
                    showCount
                    maxLength={200}
                    placeholder="用户可填写文字信息，如最终确诊非法定报告的传染病的病名等。诊断为耐多药肺结核或订正诊断为耐多药肺结核的患者在此栏补充填写“MDRTB”。"
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </Modal>

      <Modal
        className={styles.history}
        width={1200}
        style={{ height: 720, maxHeight: 720, overflow: "hidden" }}
        title="历史就诊信息"
        visible={isModalVisible}
        footer={null}
        onCancel={() => {
          historyTreatmentsRef.current?.reset()
          setIsModalVisible(false)
        }}
      >
        <HistoryTreatment
          ref={historyTreatmentsRef}
          style={{ height: "100%" }}
          timeFlag={true}
          // patientId={registration?.patientId}
          onConnect={(vs) => {
            dispatch(getPatientDetailInfoAsync({ 
              id: vs?.t?.patientId,
              insuranceCode: insuranceArray?.[0]?.insuranceCode 
            }))
            .then(unwrapResult)
            .then((res: any) => {
              setUserMessage(vs?.t)
              setIsModalVisible(false)
              setBirthDateValue(
                res?.birthday ? moment(res?.birthday) : null
              )
              form.setFieldsValue({
                name:
                  (vs?.t?.createTime
                    ? moment(vs?.t?.createTime).format(DateTimeFormatSimple)
                    : '') +
                  ' ' +
                  (vs?.t?.disease ? vs?.t?.disease : ''),
                ageYear: res?.ageYear,
                patientName: res?.name,
                sex: res?.sex > 0 ? res?.sex : undefined,
                birthDate: res?.birthday ? moment(res?.birthday) : null,
                ageMonth: res?.ageMonth,
                tel: res?.phone,
                idCard: res?.idCardNumber,
                workunit: res?.companyName,
                currentAddrDetail: res?.address,
                diagnosisDate: vs?.t?.createTime ? moment(vs?.t?.createTime) : null,
              })
            })
            setDiagnosisDateValue(vs?.t?.createTime ? moment(vs?.t?.createTime) : null)
          }}
        />
      </Modal>
    </>
  )
}
